const stopEvents = (e) => {
  if (!e) return;
  if (typeof e.stopPropagation === "function") e.stopPropagation();
  if (typeof e.preventDefault === "function") e.preventDefault();
};

export default stopEvents;
